import React from 'react';

import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';

type Props = {
  childcares?: ReadonlyArray<unknown>;
  isTransferIncluded?: boolean;
  price?: ProposalPrice;
  transferUpsell?: ReadonlyArray<UpsellTransfer>;
};

export const StaySummaryTicketUpsell = ({
  childcares,
  price,
  transferUpsell,
  isTransferIncluded,
}) => {
  const transferFormattedValue = price?.transfer?.formattedValue;
  const childcareFormattedValue = price?.childcare?.formattedValue;
  const childcarePrice = price?.childcare?.value;
  const isIncluded =
    childcares?.filter((el) => !!el.productInfo.isIncluded && !!el.pricingInfo.isPartiallyRented)
      .length > 0;
  const isOnDemand =
    childcares?.filter((el) => !el.productInfo.isIncluded && !!el.pricingInfo.isPartiallyRented)
      .length > 0;

  const mention = () => {
    if (isIncluded && isOnDemand) {
      return null;
    }
    if (isIncluded) {
      return t('booking.common.included');
    }
    if (isOnDemand) {
      return t('booking.confirmation.onDemand');
    }
  };

  if (childcares) {
    return (
      <React.Fragment>
        <p
          className={classnames('text-14', {
            'font-bold text-orange': isOnDemand,
            'font-bold text-green': isIncluded,
          })}
        >
          {mention()}
        </p>
        <p className="text-14 font-bold text-orange">
          {childcarePrice > 0 && `+${childcareFormattedValue}`}
        </p>
      </React.Fragment>
    );
  }

  if (isTransferIncluded) {
    return <p className="text-14 font-bold text-green">{t('booking.common.included')}</p>;
  }

  if (transferUpsell?.length > 0) {
    return (
      <React.Fragment>
        <p className="text-14 font-bold text-orange">{t('booking.confirmation.onDemand')}</p>
        <p className="text-14 font-bold text-orange">+ {transferFormattedValue}</p>
      </React.Fragment>
    );
  }
};
